import { GlobalSearch } from '@bbl-digital/snorre-v2'
import { usePreviousSearches } from '../hooks/usePreviousSearches'
import { FC } from 'react'
type PreviousSearchesProps = {
  onClick: (displayName: string) => void
}
export const PreviousSearches: FC<PreviousSearchesProps> = ({ onClick }) => {
  const { searches, handleClear } = usePreviousSearches()

  return (
    <GlobalSearch.PreviousSearch
      searches={searches}
      handleClick={(search) => onClick(search.displayName)}
      handleClear={(search) => handleClear(search.id)}
    />
  )
}
